<template>
  <v-container class="grey lighten-5 px-0 pb-0">
      <v-row dense class="pa-3">
        <v-col dense cols="4" class="pa-0">
<!--
          <div class="display-1" id="title">
            お申込みページ
          </div>
-->
          <img src="/img/OilMatrix_BLGR_grd_cropped.png" height="64"  />
        </v-col>
        <v-col dense cols="8" class="text-right">
          <div class="caption">
            <span class="mx-2">
              <router-link to="/FAQ" id="faqlink">
                <v-icon small>mdi-help-circle-outline</v-icon>              
                よくあるご質問
              </router-link>
            </span>
            <span class="mx-2">
              |
            </span>
            <span class="mx-2">
              <router-link to="/UserManual" id="faqlink">
                <v-icon small>mdi-book-open</v-icon>              
                ご利用マニュアル
              </router-link>
            </span>
          </div>
        </v-col>
      </v-row>

    <v-row class="mx-3">
      <v-col cols="12" lg="12" md="12" sm="12" xs="12" dense>
        <informationList></informationList>
      </v-col>
    </v-row>

    <v-row class="mx-12">
      <v-col cols="12" lg="12" md="12" sm="12" xs="12" dense>
        <span>OilMatrix ジャパン・アナリスト™へようこそ。<br>
        フローに沿って「OilMatrix ジャパン・アナリスト™」から分析・診断サービスにお申込みください。<br><br>
        初めてご利用の方は、
        </span>
        <span class="mx-2">
          <router-link to="/UserManual" id="faqlink">
            ご利用マニュアル
          </router-link>
        </span>
        <span>をご覧いただき、本サービスからの分析依頼の流れをご確認下さい。<br>
        </span>
      </v-col>
    </v-row>

  <v-timeline dense class="pr-3">


      <v-timeline-item fill-dot small>
        <v-card class="pa-2">
          <div class="title">分析依頼の準備</div>
          <v-divider class="mt-2"></v-divider>
          <v-row dense class="mt-2">
            <v-col dense cols="2" md="1">
              <img src="/img/getready.png" style="max-width:100%">
            </v-col>
            <v-col dense cols="8" md="10">
              <span class="body-2">
                OilMatrix ジャパン・アナリスト™からのご依頼時に使用する採油ボトルや通い箱に貼り付けるラベルシート（専用台紙）をご準備ください。<br>
                また、分析・診断サービスをご利用いただくお客様限定で採油ボトルや採油チューブ、サンプル郵送時の通い箱をご提供しております。<br>
                ご入用の場合は下記のご注文フォームよりお申しつけください。<br>
              </span>
              <div class="my-2">
                <v-btn small rounded color="amber darken-1" @click="openExternalLink('https://www.japan-analysts.com/label-sheet-order/')" class="mx-2" style="text-transform: none;">
                  <v-icon class="mr-2">mdi-tray-full </v-icon>OilMatrix専用ラベルシート（専用台紙）のご注文
                </v-btn>
                <v-btn small rounded color="amber darken-1" @click="openExternalLink('https://www.japan-analysts.com/sampling-container-request/')" class="mx-2">
                  <v-icon class="mr-2">mdi-bottle-tonic-plus</v-icon>採油ボトル・通い箱の手配
                </v-btn>
<!--
                <v-btn small rounded color="amber darken-1" @click="openExternalLink('https://www.japan-analysts.com/sampling-container-purchase/')" class="mx-2">
                  <v-icon class="mr-2">mdi-open-in-new</v-icon>採油ボトル・採油ポンプのご購入
                </v-btn>
-->                
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-timeline-item>





      <v-timeline-item fill-dot small>
        <v-card class="pa-2">
          <div class="title">１．マイ機器の管理（登録／変更／削除）</div>
          <v-divider class="mt-2"></v-divider>
          <v-row dense class="mt-2">
            <v-col dense cols="2" md="1">
              <img src="/img/qr.png" style="max-width:100%">
            </v-col>
            <v-col dense cols="8" md="10">
              <span class="body-2">
                マイ機器メニューより、分析対象となるオイルを使用している機器を「マイ機器」として登録してください。<br>
                オイルを利用している機器の情報やオイルの情報、分析依頼内容など分析依頼時に必要な情報を登録しておくことができます。<br>
                また、マイ機器毎の専用のQRコードを印刷して機器に貼り付けておくと、分析サンプル情報を効率的に登録できるのでオススメです。
              </span>
              <div class="my-2">
<!--      
                <v-btn small rounded color="amber darken-1" :to="{ path: 'selectmachinetype'}" class="mx-2">
-->
                <v-btn small rounded color="amber darken-1" @click="gotoCreateMachine" class="mx-2">
                  <v-icon class="mr-2">mdi-plus</v-icon>マイ機器を登録
                </v-btn>

                <v-btn small rounded color="amber darken-1" :to="{ path: 'mymachinelist'}" class="mx-2">
                  <v-icon class="mr-2">mdi-forklift</v-icon>マイ機器リスト
                </v-btn>


                <v-btn small rounded color="amber darken-1" @click="goQRprint" class="mx-2">
                  <v-icon class="mr-2">mdi-qrcode</v-icon>マイ機器QRコード印刷
                </v-btn>


              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-timeline-item>

      <v-timeline-item fill-dot small>
        <v-card class="pa-2">
          <div class="title">２．分析サンプルの登録</div>
          <v-divider class="mt-2"></v-divider>
          <v-row dense class="mt-2">
            <v-col dense cols="2" md="1">
              <img src="/img/harvesting.png" style="max-width:100%">
            </v-col>
            <v-col dense cols="8" md="10">
              <span class="body-2">
                分析サンプルを登録します。<br>
                <br>
                マイ機器登録した内容を元に登録する<strong>「マイ機器から分析サンプルを登録する」</strong>か<br>
                分析するオイル情報を直接入力する<strong>「分析サンプルを直接登録する」</strong>から登録してください。<br>
              </span>
            </v-col>
          </v-row>
          <v-card-actions>
            <span class="title my-5 mx-2" >２．１</span><span class="title mx-2" style="border-bottom: solid 1px #D3D3D3;" @click=switchSamplingType(1)>マイ機器から分析サンプルを登録する</span>
            <v-btn
              icon
              @click=switchSamplingType(1)
            >
              <v-icon>{{ show1 ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
            </v-btn>
          </v-card-actions>
          <v-expand-transition>
            <div v-show="show1">
              <v-divider></v-divider>
              <v-row class="mx-3" >
<!--
            <v-col cols="12" lg="12" md="12" sm="12" xs="12" dense>
              <span class="title px-3 my-3">２．１ マイ機器から分析サンプルを登録（定期分析）</span>
            </v-col>
-->
                <v-col cols="12" lg="12" md="12" sm="12" xs="12" dense >
                  <v-row class="mx-3" dense >
                    <v-col cols="12" lg="12" md="12" sm="12" xs="12" dense>
                      <span class="body-2">
                        あらかじめマイ機器登録した内容でサンプル情報が自動的に入力設定されます。<br>
                        マイ機器一覧の「サンプル採取ボタン」をクリックしてください。<br>
                        機器毎に発行される「マイ機器QRコード」をスキャンしていただくとダイレクトにサンプル登録こともできます。
                      </span>
                    </v-col>
                    <v-col cols="12" lg="12" md="12" sm="12" xs="12" dense>
                      <machineList></machineList>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </div>
          </v-expand-transition>

          <v-card-actions>
            <span class="title mx-2" >２．２</span><span class="title mx-2" style="border-bottom: solid 1px #D3D3D3;" @click=switchSamplingType(2)>分析サンプルを直接登録する</span>
            <v-btn
              icon
              @click=switchSamplingType(2)
            >
              <v-icon>{{ show2 ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
            </v-btn>
          </v-card-actions>
          <v-expand-transition mode="out-in">
            <div v-show="show2">
              <v-divider></v-divider>
                <v-row class="mx-3" >
<!--
            <v-col cols="12" lg="12" md="12" sm="12" xs="12" dense>
              <span class="title px-3 my-3">２．２ 分析サンプル直接入力</span>
            </v-col>
-->
                <v-col cols="12" lg="12" md="12" sm="12" xs="12" dense>
                  <v-row class="mx-3" dense >
                    <v-col cols="12" lg="12" md="12" sm="12" xs="12" dense>
                      <span class="body-2">
                        分析するオイル情報を直接入力して登録します。<br>
                        <!--
                        新しいオイルのご利用になる前の異物液体などの不純物を点検でご利用ください。<br>
                        -->
                      </span>
                    </v-col>
                  </v-row>
                  <v-row  >
                    <v-col cols="12" lg="12" md="12" sm="12" xs="12" dense>
<!--
                        :to="{ path: 'spotsampling'}"
-->
                      <v-btn
                        small
                        rounded
                        color="amber darken-1"
                        @click="gotoSpotSampling"
                        class="mx-2"
                        large
                      >
                        <v-icon class="mr-2">mdi-cup-water x-large</v-icon>分析サンプル直接入力
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </div>
          </v-expand-transition>
          
        </v-card>
      </v-timeline-item>

      <v-timeline-item fill-dot small>
        <v-card class="pa-2">
          <div class="title">３．分析依頼</div>
          <v-divider class="mt-2"></v-divider>
          <v-row dense class="mt-2">
            <v-col dense cols="2" md="1">
              <img src="/img/request.png" style="max-width:100%">
            </v-col>
            <v-col dense cols="8" md="10">
              <span class="body-2">
                分析のご依頼は「新しい分析依頼」ボタンをクリックしてOilMatrixの分析依頼専用フォームよりお申込みください。<br>
                分析のご依頼の前にお見積書が必要な場合は「新しいお見積依頼」ボタンをクリックしてOilMatrixのお見積り依頼専用フォームよりお見積が作成できます。<br>
                <br>
                分析依頼には、事前に採取サンプルの登録が完了している必要があります。<br>
                下記の「登録済み分析サンプル一覧」に依頼する分析サンプルが登録されていることを確認してください。
              </span>
              <div class="my-2">
                <v-tooltip right color="grey" transition="slide-x-transition">
                  <template v-slot:activator="{ on }">
<!--
                      :to="{ path: 'selectapplicationtype'}"
-->
                  <v-btn
                    large
                    rounded
                    v-on="on"
                    color="amber darken-1"
                    @click="gotoApplication"
                    class="mx-2">
                    <v-icon class="mr-2">mdi-plus</v-icon> 新しい分析依頼
                  </v-btn>
                  </template>
                  <span>分析を依頼する場合にこのボタンをクリックしてください。</span>
                </v-tooltip>
                <v-tooltip right color="grey" transition="slide-x-transition">
                  <template v-slot:activator="{ on }">
<!--
                  <v-btn large rounded v-on="on" color="amber darken-1" :to="{ path: 'selectquotetype'}" class="mx-2">
-->
                  <v-btn large rounded v-on="on" color="amber darken-1" @click="gotoQuote" class="mx-2">
                    <v-icon class="mr-2">mdi-calculator</v-icon> 新しいお見積依頼
                  </v-btn>
                  </template>
                  <span>お見積を依頼する場合にこのボタンをクリックしてください。</span>
                </v-tooltip>
              </div>
            </v-col>
          </v-row>
          <v-row class="mx-3">
            <v-col cols="12" lg="12" md="12" sm="12" xs="12" dense>
              <sampleList></sampleList>
            </v-col>
          </v-row>
        </v-card>
      </v-timeline-item>

      <v-timeline-item fill-dot small>
        <v-card class="pa-2">
          <div class="title">４．お申込み履歴の確認</div>
          <v-divider class="mt-2"></v-divider>
          <v-row dense class="mt-2">
            <v-col dense cols="2" md="1">
              <img src="/img/shipping.png" style="max-width:100%">
            </v-col>
            <v-col dense cols="8" md="10">
              <span class="body-2">
                OilMatrix よりお申込みいただいた分析依頼の履歴を確認することができます。<br>
                下記の「分析依頼一覧」の確認したい依頼をクリックしてください。
              </span>
            </v-col>
          </v-row>
          <v-row class="mx-3">
            <v-col cols="12" lg="12" md="12" sm="12" xs="12" dense>
              <applicationList></applicationList>
            </v-col>
          </v-row>
        </v-card>
      </v-timeline-item>


  </v-timeline>

    <!-- <officeSnack></officeSnack> -->
    <machine-qr ref="isQRprint"></machine-qr>

  </v-container>
</template>

<script>
//import Vue from 'vue'
//  import { API, graphqlOperation} from "aws-amplify"
//import deleteSampleConfirm from '../components/DeleteSampleConfirm'
import informationList from '../components/Information'
import applicationList from '../components/ApplicationList'
import sampleList from '../components/SampleList'
import machineList from '../components/MyMachineListComp'
import MyMachineQRmodal from '../components/MyMachineQRmodal'

const sleep = msec => new Promise(resolve => setTimeout(resolve, msec));

// import officeSnack from '../components/officeSnack'

// import faqList from '../components/faq'
//import { listInformations } from '../graphql/queries'
// import { sortedlistFaQs } from '../graphql/queries'
//import { searchInformations } from '../graphql/queries'

export default {
  name: 'Mypage',
  components:{
//    deleteSampleConfirm,
    informationList,
    applicationList,
    sampleList,
    machineList,
    machineQr : MyMachineQRmodal
    // officeSnack
  },
  head: {
    title: { inner: 'お申込みページ'},
  },
  data() {
    return {
      // informationList: [],
      // FaqList: [],
/*
      dialog: false,

      search: '',
      page: 1,
      pageCount: 0,
      itemsPerPage: 5,
      itemsPerPageList: [ 5,10,30 ],
      sampleListheaders: [
        {
          text: 'サンプル名',
          align: 'start',
          sortable: false,
          value: 'Name',
        },
        {
          text: '機器ＩＤ',
          value: 'CustomerMachineID'
        },
        {
          text: '採取日',
          value: 'SamplingAt'
        },
        {
          text: 'ボトル数',
        },
        {
          text: '削除',
          value: 'actions'
        },
      ],
      samples: [],
*/
/*
      applicationListheaders: [
        {
          text: '受注番号',
        },
        {
          text: '担当者',
        },
        {
          text: 'サンプル数',
        },
        {
          text: '申込み日',
          value: 'OrderAt'
        },
        {
          text: 'ステータス',
        },
        {
          text: 'お申込み番号',
          value: 'id'
        },
      ],
      applications: [],
*/
    show1: false,
    show2: false,
    }
  },
  mounted: async function () {

  console.log("process.env", process.env)

/*
    //  全カラムの一覧を取る場合はこの1行でOK
    //  let machines = await API.graphql(graphqlOperation(listMachines, {limit: 100, items: "Name,  CustomerMachineID, OperatingTime, OperatingTimeUnit"}))
    //  取得するカラムを指定する場合はこのように書く。
    const samplesByOfficeQuery = `query samplesByOffice {
      samplesByOffice(limit: 100, OfficeID: "office9999999") {
        items {
          id
          Name
          CustomerMachineID
          SamplingAt
        }
      }
      }`;
    let samples = await API.graphql(graphqlOperation(samplesByOfficeQuery))
    console.log("samples:", samples);
    this.samples = samples.data.samplesByOffice.items;
*/
/*
    const applicationsByOfficeQuery = `query applicationsByOffice {
      applicationsByOffice(limit: 100, OfficeID: "office9999999") {
        items {
          id
          OrderAt
        }
     }
      }`;
    let applications = await API.graphql(graphqlOperation(applicationsByOfficeQuery))

//    let applications = await API.graphql(graphqlOperation(applicationsByOffice, {limit: 100, OfficeID: "office9999999"}))

    console.log("applications:", applications);
    this.applications = applications.data.applicationsByOffice.items;
*/
    var now = new Date();
    var yyyy = now.getFullYear();
    var mm = ("00" + (now.getMonth()+1)).slice(-2);
    var dd = ("00" + now.getDate()).slice(-2);
    var today = yyyy + "-" + mm + "-" + dd;
    console.log("today:",today);

    // let filter = {
    //   and: [{
    //     NoticeFrom:{
    //       le: today
    //     },
    //     NoticeTo:{
    //       ge: today
    //     },
    //   }
    //   ]
    // }
    // let informations = await API.graphql(graphqlOperation(listInformations, {limit: 100, filter:filter }))
    // this.informationList = informations.data.listInformations.items
    // 開始日の昇順（降順にするには、1と-1を逆
    // queryでsortがうまくいかなかったのでしょうがなく。
    // this.informationList.sort(function(a, b) {
    //     if (a.NoticeFrom > b.NoticeFrom) { return 1; }
    //     if (a.NoticeFrom < b.NoticeFrom) { return -1; }
    //     return 0;
    // })
    // console.log("informations:",this.informationList);

    // let FaQs = await API.graphql(graphqlOperation(sortedlistFaQs, {limit: 100, isActive: '1' }))
    // this.FaqList = FaQs.data.sortedlistFAQs.items
    // console.log("FaQs:",this.FaqList);

  },
  computed : {
  },
  methods: {
    goQRprint: async function () {
      this.$refs.isQRprint.open();
      // console.log('goQRprint')
    },

/*
      showDialog() {
        this.$refs.deletedialog.open();
      }
*/
    gotoCreateMachine: function() {
      let AnalizeTypeGroup = this.$store.state.operatingCompany.AnalizeTypeGroup
      console.log("得意先.依頼区分:", AnalizeTypeGroup)
      // 得意先.依頼区分が一般の場合はマイ機器作成（一般、装備・装置）
      if(AnalizeTypeGroup == "一般") {
          this.$router.push("/mymachine?type=" + "装備装置" + "&category=" + "一般")
      // 得意先.依頼区分が航空機の場合、登録マイ機器の種別選択画面
      }else {
        this.$router.push("/selectmachinetype")
      }
    },
    gotoQuote: function() {
      let AnalizeTypeGroup = this.$store.state.operatingCompany.AnalizeTypeGroup
      console.log("得意先.依頼区分:", AnalizeTypeGroup)
      // 得意先.依頼区分が一般の場合はマイ機器作成（一般、装備・装置）
      if(AnalizeTypeGroup == "一般") {
          this.$router.push("/quote?category=" + "一般")
      // 得意先.依頼区分が航空機の場合、登録マイ機器の種別選択画面
      }else {
        this.$router.push("/selectquotetype")
      }
    },

    gotoApplication: function() {
      let AnalizeTypeGroup = this.$store.state.operatingCompany.AnalizeTypeGroup
      console.log("得意先.依頼区分:", AnalizeTypeGroup)
      // 得意先.依頼区分が一般の場合はマイ機器作成（一般、装備・装置）
      if(AnalizeTypeGroup == "一般") {
          this.$router.push("/application?category=" + "一般")
      // 得意先.依頼区分が航空機の場合、登録マイ機器の種別選択画面
      }else {
        this.$router.push("/selectapplicationtype")
      }
    },

    gotoSpotSampling: function() {
      let AnalizeTypeGroup = this.$store.state.operatingCompany.AnalizeTypeGroup
      console.log("得意先.依頼区分:", AnalizeTypeGroup)
      // 得意先.依頼区分が一般の場合はマイ機器作成（一般、装備・装置）
      if(AnalizeTypeGroup == "一般") {
          this.$router.push("/spotsampling?category=" + "一般")
      // 得意先.依頼区分が航空機の場合、登録マイ機器の種別選択画面
      }else {
        this.$router.push("/selectspotsamplingtype")
      }
    },

    switchSamplingType: async function(type) {
      if(type==1) {
        this.show2 = false
        await sleep(300);
        this.show1 = true
      }else {
        this.show1 = false
        await sleep(300);
        this.show2 = true
      }
    },

    openExternalLink: function(url) {
      window.open(url, '_blank');
    }
  },
}
</script>

<style lang="scss" scoped>
#faqlink {
  text-decoration: none !important;
}
#faqlink:hover {
  text-decoration: underline !important;
}
</style>